import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';

import ScoopsPageContent from './ScoopsPageContent';
import { ScoopsPageProps } from './interfaces';

const queryClient = new QueryClient();

const ScoopsPage = ({
  articles,
  mostPopularArticles,
  communityComments,
  initialCurrentUser,
  env,
  isGdprRequired,
  isWebview,
  upcomingEvents,
  briefingNewsletter,
}: ScoopsPageProps) => {
  return (
    <AppContextProvider
      env={env}
      initialCurrentUser={initialCurrentUser}
      isGdprRequired={isGdprRequired}
      isWebview={isWebview}
    >
      <QueryClientProvider client={queryClient}>
        <ScoopsPageContent
          upcomingEvents={upcomingEvents}
          articles={articles}
          mostPopularArticles={mostPopularArticles}
          communityComments={communityComments}
          briefingNewsletter={briefingNewsletter}
        />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default ScoopsPage;
